import React, { useCallback, useState } from "react";
import { faBookmark, faShareNodes } from "@fortawesome/pro-regular-svg-icons";
import {
  faBookmark as faBookmarkSolid,
  faSpinnerThird,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment-timezone";
import { Link } from "react-router-dom";

import "./CardSearch.scss";
import { Helpers } from "../services/Helpers";

export default function CardSearch({
  showFavoriteIcon,
  card,
  api,
  callbackFavorite,
}) {
  const [limitTag, setLimitTag] = useState(3);
  const [loadingBtn, setLoadingBtn] = useState(false);

  const setFavorite = useCallback(() => {
    setLoadingBtn(true);
    api(
      `api/providers/${process.env.REACT_APP_SLUG}/content-videos/${card.id}/favorites/check/`,
      {
        method: "PATCH",
      },
    ).then(({ ok }) => {
      if (ok) callbackFavorite.favorited(card.id);
      setLoadingBtn(false);
    });
  }, [api, card, callbackFavorite]);

  const setUnFavorite = useCallback(() => {
    setLoadingBtn(true);
    api(
      `api/providers/${process.env.REACT_APP_SLUG}/content-videos/${card.id}/favorites/uncheck/`,
      {
        method: "DELETE",
      },
    ).then(({ ok }) => {
      if (ok) callbackFavorite.unFavorited(card.id);
      setLoadingBtn(false);
    });
  }, [api, card, callbackFavorite]);

  const onChangeFavorite = useCallback(() => {
    if (card.favorited) setUnFavorite();
    else setFavorite();
  }, [card, setFavorite, setUnFavorite]);

  return (
    <div className="card-search">
      <div className="thumbnail">
        {card.thumbnail ? (
          <figure>
            <img src={card.thumbnail} alt="thumb" />
          </figure>
        ) : null}
        <div className="overlay"></div>
        <p>{Helpers.secondsInTime(card.duration)}</p>
        <Link to={"/event/" + card.id} className="bw-event-btn">
          Watch now
        </Link>
      </div>
      <div className="content">
        <div className="wrapper-show-info">
          <h4>{card.topic}</h4>
          <h2>{card.title}</h2>
          <div className="tags">
            {card.topics && card.topics.length
              ? card.topics.slice(0, limitTag).map((item, key) => (
                  <Link
                    to={"/search?search=" + item.name}
                    className="bw-event-btn tag"
                    key={key}
                  >
                    {item.name}
                  </Link>
                ))
              : null}
            {limitTag < card.topics.length ? (
              <button
                className="bw-event-btn"
                onClick={() => setLimitTag(card.topics.length)}
              >
                +{card.topics.length - limitTag} more
              </button>
            ) : null}
          </div>
          <p>Added {moment(card.created_at).fromNow()}</p>
        </div>
        <div className="wrapper-hide-info">
          <div className="info-footer py-2">
            <div className="actions">
              {showFavoriteIcon ? (
                <>
                  {!loadingBtn ? (
                    <button
                      className={
                        "bw-event-btn favorite " +
                        (card.favorited ? "is-favorite" : "")
                      }
                      onClick={onChangeFavorite}
                    >
                      <FontAwesomeIcon
                        className="not-favorite"
                        icon={faBookmark}
                        style={{ color: "#212121" }}
                      />
                      <FontAwesomeIcon
                        className="is-favorite"
                        icon={faBookmarkSolid}
                        style={{ color: "#212121" }}
                      />
                    </button>
                  ) : (
                    <div className="bw-event-btn-loading">
                      <FontAwesomeIcon icon={faSpinnerThird} />
                    </div>
                  )}
                </>
              ) : null}

              <button className="bw-event-btn share">
                <FontAwesomeIcon
                  icon={faShareNodes}
                  style={{ color: "#212121" }}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
